// src/TokenManager.js

// 이 객체는 앱의 생명주기 동안 토큰 값을 저장하고 관리합니다.
const TokenManager = {
  currentToken: null,

  // 서버로부터 받은 새 토큰을 저장(갱신)하는 함수
  setToken(newToken) {
    console.log(`🔑 Token updated: ${this.currentToken} -> ${newToken}`);
    this.currentToken = newToken;
  },

  // 현재 저장된 토큰을 가져오는 함수
  getToken() {
    return this.currentToken;
  }
};

export default TokenManager;
